<template>
  <div>
    <div class="card card-body rounded-top">
      <div class="row no-gutters row-grid">
        <div class="col-12">
          <div class="d-flex flex-column align-items-center justify-content-center p-4">
            <img
              v-if="club.mainImageId"
              :src="club.mainImageId | avatarUrl"
              width="250"
              height="300"
              class="rounded-circle shadow-2 img-thumbnail"
              alt
            />

            <h1 class="mb-0 fw-700 text-center mt-3">{{ club.name }}</h1>
          </div>
        </div>
      </div>

      <div class="row no-gutters row-grid">
        <detail-item class="col-md-4" label="text.club.email">{{ club.email || 'Brak' }}</detail-item>

        <detail-item class="col-md-4" label="text.club.phoneNumber">{{ club.phoneNumber || 'Brak' }}</detail-item>

        <detail-item class="col-md-4" label="text.club.www">{{ club.www || 'Brak' }}</detail-item>
      </div>

      <div class="row no-gutters row-grid">
        <detail-item class="col-12">
          <p slot="outerText">{{ club.description }}</p>
        </detail-item>
      </div>

      <div class="row no-gutters row-grid">
        <detail-item class="col-12" label="text.club.address">{{ club | address }}</detail-item>
      </div>

      <div class="row no-gutters row-grid">
        <div class="col-12 text-center">
          <check-permission permissions="OFFER.ADD" entityType="profile" :entityId="profileId">
            <check-permission
              entityType="club"
              joinType="OR"
              render-on="unauthorized"
              :entityId="club.id"
              :permissions="['CLUB.UPDATE','CLUB.FEES']"
            >
              <button
                class="btn btn-smart btn-lg rounded-pill px-5 m-5"
                @click.prevent="openOfferModal"
              >
                <i class="fal fa-fw fa-plus mr-1" />

                <span>{{ $t('buttons.join-club') }}</span>
              </button>
            </check-permission>
          </check-permission>
        </div>
      </div>

      <div class="row no-gutters row-grid">
        <div class="col-12">
          <map-component v-if="marker" :marker="marker" />
        </div>
      </div>
    </div>

    <offer-modal
      :show="offerModal"
      :clubId="club.id"
      :profileId="profileId"
      @close="closeOfferModal"
      @save="saveOffer"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import OfferModal from '@/components/modals/OfferModal';
import MapComponent from '@/components/map/Map';
import DetailItem from '@/components/details/DetailItem';
import { getProfileId } from '@/utils';
import { notificationsMixin } from '@/mixins/notifications';

const messages = {
  added: 'Wniosek o dołączenie do klubu został wysłany.',
  addError: 'Nie udało się dodać wniosku.'
};
// @vuese
// Szczegóły klubu
// @group Club
export default {
  components: { DetailItem, MapComponent, OfferModal },
  mixins: [notificationsMixin],
  computed: {
    ...mapState({
      club: state => state.club.data,
      marker: state => {
        const { lat, lng, name } = state.club.data;
        if (lat && lng) {
          return { lat, lng, text: name };
        }
      }
    })
  },
  methods: {
    // @vuese
    // Otworzenie modala dodawnia wniostku
    openOfferModal() {
      this.offerModal = true;
    },
    // @vuese
    // Zamknięcie modala dodawnia wniostku
    closeOfferModal() {
      this.offerModal = false;
    },
    // @vuese
    // Zapisanie wniostku
    saveOffer(data) {
      this.$store
        .dispatch('club/offers/add', data)
        .then(() => {
          this.notifySuccess('messages.offer.addedSend');
          this.closeOfferModal();
        })
        .catch(err => {
          err.message ? this.notifyError(messages.addError, [err.message]) : this.notifyError(messages.addError);
        });
    }
  },
  data() {
    return {
      offerModal: false,
      profileId: getProfileId()
    };
  }
};
</script>
